import { PLACE_ACTION_TYPES } from '../../actions/place/place_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const places = (state = initialState, action) => {
    switch (action.type) {
        case PLACE_ACTION_TYPES.GET_PLACES_SUCCESS:
            return { ...state, collection: action.payload };
        case PLACE_ACTION_TYPES.POST_PLACE_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case PLACE_ACTION_TYPES.PUT_PLACE_SUCCESS:
            const updatedPlace = action.payload;
            return { ...state, collection: state.collection.map((place) => place.uuid !== updatedPlace.uuid ? place : { ...place, ...updatedPlace }) };
        case PLACE_ACTION_TYPES.UPDATE_PLACES_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
